<template>
  <div class="w-full flex justify-center bg-paper-white overflow-y-auto">
    <div class="max-w-[768px] flex justify-center items-center w-full h-dvh">
      <div class="w-full">
        <slot/>
      </div>
    </div>
  </div>
</template>
